import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthService, HandleErrorsService, PrintingService } from '../app-services';

export const hasAccessToPrintingsGuard: CanActivateFn = route => {
  const authService = inject(AuthService);
  const printingService = inject(PrintingService);
  const handleErrors = inject(HandleErrorsService);

  if (authService.isSuperAdmin()) {
    return of(true);
  }

  if (authService.isAdmin()) {
    return printingService.getPrintingList({ ids: [route.params['id']] }).pipe(
      map(adminPrintings => !!adminPrintings.listing.find(printing => printing.id === +route.params['id'])),
      catchError(err => {
        handleErrors.handleErrors(err);

        return throwError(() => err);
      }),
    );
  }

  return of(false);
};
